import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import { useDispatch } from 'react-redux';
import { MENU_OPEN } from '../../../store/actions';
import Logo from '../../../component/Logo';
import config from 'config';

// ==============================|| MAIN LOGO ||============================== //

function LogoSection() {
    const dispatch = useDispatch();
    return (
        <ButtonBase
            disableRipple
            component={Link}
            to={config.defaultPath}
            onClick={() => {
                dispatch({ type: MENU_OPEN, id: undefined });
            }}
        >
            <Logo />
        </ButtonBase>
    );
}

export default LogoSection;
